/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomTabs from "../components/CustomTabs";
import StudentExamDetails from "./StudentExamDetails";
import ParticularStudentAttendanceReport from "./ParticularStudentAttendanceReport";
import ParticularStudentFeeReport from "./ParticularStudentFeeReport";

function ParticularStudentDetails() {
  const { id, seid } = useParams();
  const navigate = useNavigate();
  const [theme] = useState(localStorage.getItem("theme"));

  const tabs = [
    {
      title: "Exam",
      eventKey: "first",
      Component: StudentExamDetails,
      props: { message: "Hello from First Component" },
    },
    {
      title: "Attendance",
      eventKey: "second",
      Component: ParticularStudentAttendanceReport,
      props: { count: 42 },
    },
    // {
    //   title: "Fees",
    //   eventKey: "third",
    //   Component: ParticularStudentFeeReport,
    //   props: { count: 42 },
    // },
  ];

  return (
    <div className="page-content-wrapper mt-0 bg-white">
      {/* Fixed Header */}
      <div className="position-fixed top-0 start-0 w-100 z-1 bg-white shadow-sm">
        <div className="bg-white py-1 px-1" id="headerArea">
          <div className="container">
            <div className="d-flex align-items-center pt-2 justify-content-between">
              <div className="d-flex">
                <Link onClick={() => navigate(-1)} className="btn p-0">
                  <small>
                    <i
                      className={`fa fa-arrow-left fa-2x ${
                        theme === "dark" ? "text-light" : "text-dark"
                      }`}
                      aria-hidden="true"
                    ></i>
                  </small>
                </Link>
              </div>
              <div className="d-flex">
                <h2 className="m-0">Reports</h2>
              </div>
              <div className="d-flex">
                <Link to="/home" style={{ fontSize: "12px" }}>
                  <small>
                    <i
                      className={`bi bi-house text-white ${
                        theme === "dark" ? "text-light" : "text-dark"
                      }`}
                      style={{ fontSize: "24px" }}
                    ></i>
                  </small>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scrollable Content */}
      <div
        className=""
        style={{
          marginTop: "80px", // height of the fixed header
          height: "calc(100vh - 80px)", // fill remaining space
          overflowY: "auto",
        }}
      >
        <CustomTabs tabs={tabs} />
      </div>
    </div>
  );
}

export default ParticularStudentDetails;
